module.exports = __webpack_public_path__ + "static/media/qempo-flash.c715576d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/qempo-flash.png
// module id = 2257
// module chunks = 0